module.exports = __webpack_public_path__ + "static/media/close.062f596b.svg";